import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
} from '@mui/material';
import { useGlobal } from '../contexts/GlobalContext';

const SettingsModal = ({ open, onClose }) => {
  const {
    baseServiceUrl,
    defaultFarcasterUserId,
    defaultPolymarketWalletAddress,
    defaultKalshiWalletAddress,
    updateBaseServiceUrl,
    updateDefaultFarcasterUserId,
    updateDefaultPolymarketWalletAddress,
    updateDefaultKalshiWalletAddress,
  } = useGlobal();
  const [tempBaseServiceUrl, setTempBaseServiceUrl] = useState(baseServiceUrl);
  const [tempDefaultFarcasterUserId, setTempDefaultFarcasterUserId] = useState(defaultFarcasterUserId);
  const [tempDefaultPolymarketWalletAddress, setTempDefaultPolymarketWalletAddress] = useState(
    defaultPolymarketWalletAddress
  );
  const [tempDefaultKalshiWalletAddress, setTempDefaultKalshiWalletAddress] = useState(
    defaultKalshiWalletAddress
  );

  const handleSave = () => {
    updateBaseServiceUrl(tempBaseServiceUrl);
    updateDefaultFarcasterUserId(tempDefaultFarcasterUserId);
    updateDefaultPolymarketWalletAddress(tempDefaultPolymarketWalletAddress);
    updateDefaultKalshiWalletAddress(tempDefaultKalshiWalletAddress);
    onClose();
  };

  const handleCancel = () => {
    setTempBaseServiceUrl(baseServiceUrl);
    setTempDefaultFarcasterUserId(defaultFarcasterUserId);
    setTempDefaultPolymarketWalletAddress(defaultPolymarketWalletAddress);
    setTempDefaultKalshiWalletAddress(defaultKalshiWalletAddress);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleCancel} maxWidth="sm" fullWidth>
      <DialogTitle>API Configuration</DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 1 }}>
          <TextField
            margin="dense"
            label="Base Service URL"
            type="url"
            fullWidth
            variant="outlined"
            value={tempBaseServiceUrl}
            onChange={(e) => setTempBaseServiceUrl(e.target.value)}
            helperText="Base URL for all API requests (defaults to this page's origin)"
            sx={{ mb: 2 }}
          />
          <TextField
            margin="dense"
            label="Default Farcaster User ID"
            type="text"
            fullWidth
            variant="outlined"
            value={tempDefaultFarcasterUserId}
            onChange={(e) => setTempDefaultFarcasterUserId(e.target.value)}
            helperText="Default Farcaster user ID to use in queries when not specified"
            sx={{ mb: 2 }}
          />
          <TextField
            margin="dense"
            label="Default Polymarket Wallet Address"
            type="text"
            fullWidth
            variant="outlined"
            value={tempDefaultPolymarketWalletAddress}
            onChange={(e) => setTempDefaultPolymarketWalletAddress(e.target.value)}
            helperText="Default Polymarket wallet address to use in Polymarket story queries"
            sx={{ mb: 2 }}
          />
          <TextField
            margin="dense"
            label="Default Kalshi Wallet Address"
            type="text"
            fullWidth
            variant="outlined"
            value={tempDefaultKalshiWalletAddress}
            onChange={(e) => setTempDefaultKalshiWalletAddress(e.target.value)}
            helperText="Default Kalshi wallet address to use in Kalshi wallet boost queries"
            sx={{ mb: 2 }}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel}>Cancel</Button>
        <Button onClick={handleSave} variant="contained">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SettingsModal;
